import Splitting from 'splitting';
import _ from 'lodash';

const DEFAULT_OPTIONS = {
  delay: 0,
};

export default (element, options = {}) => {
  const [splitText] = Splitting({
    target: element,
    by: 'chars',
  });

  options = {
    ...DEFAULT_OPTIONS,
    ...options,
  };

  const { chars } = splitText;
  const shuffled = _.shuffle(chars);
  let elementVisible = false;

  const flicker = (char, i) => {
    if (!elementVisible) {
      element.style.visibility = 'visible';
      elementVisible = true;
    }

    if (element.classList.contains('invisible')) {
      element.classList.remove('invisible');
    }

    char.style.opacity = 0;

    const delay = (i + 1) * 10;

    setTimeout(() => {
      char.classList.add('flicker-in');
    }, delay);
  };

  if (options.delay > 0) {
    const animationDelay = options.delay * 1000;
    setTimeout(() => {
      shuffled.forEach(flicker);
    }, animationDelay);
  } else {
    shuffled.forEach(flicker);
  }
};
